import { mPerLat, mPerLon } from '../lib/geo';
import { useEffect, useState } from 'react';
import { orderStops, routeLegs } from '../lib/route';

export const dist = (a, b) => Math.hypot((a.lat - b.lat) * mPerLat(a.lat), (a.lon - b.lon) * mPerLon(a.lat));
export const fmtDist = (d) => (d < 1000 ? `${Math.round(d)} m` : `${(d / 1000).toFixed(1).replace('.', ',')} km`);

export function usePos(on) {
  const [p, setP] = useState(null);
  useEffect(() => {
    if (!on || !navigator.geolocation) return undefined;
    const id = navigator.geolocation.watchPosition((x) => setP({ lat: x.coords.latitude, lon: x.coords.longitude, acc: x.coords.accuracy }), () => {}, { enableHighAccuracy: true, maximumAge: 2000 });
    return () => navigator.geolocation.clearWatch(id);
  }, [on]);
  return p;
}

export function ModePick({ t, v, onChange, pre }) {
  return (
    <div className="lp-mode" data-testid={`${pre}-mode`}>
      <div className="lg-durs">
        <button type="button" className={`chip seg ${v.mode === 'perm' ? 'on' : ''}`} data-testid={`${pre}-mode-perm`} onClick={() => onChange({ ...v, mode: 'perm' })}>{t.lpPerm}</button>
        <button type="button" className={`chip seg ${v.mode === 'lift' ? 'on' : ''}`} data-testid={`${pre}-mode-lift`} onClick={() => onChange({ ...v, mode: 'lift' })}>{t.lpLift}</button>
      </div>
      {v.mode === 'lift' && (
        <div className="lg-durs">
          {[1, 2, 3, 7].map((x) => <button key={x} type="button" className={`chip seg ${v.days === x ? 'on' : ''}`} data-testid={`${pre}-days-${x}`} onClick={() => onChange({ ...v, days: x })}>{x} {t.lgDays}</button>)}
          <input className="lp-days" inputMode="numeric" data-testid={`${pre}-days-input`} aria-label={t.lgDays} value={v.days} onChange={(e) => onChange({ ...v, days: Math.max(1, Math.min(60, parseInt(e.target.value, 10) || 1)) })} />
        </div>
      )}
    </div>
  );
}

// where to put the logger: own GPS position or the map crosshair
export function PosPick({ t, pos, src, setSrc, pre }) {
  return (
    <div className="lg-durs lp-src" data-testid={`${pre}-src`}>
      <button type="button" disabled={!pos} className={`chip seg ${src === 'gps' ? 'on' : ''}`} data-testid={`${pre}-src-gps`} onClick={() => setSrc('gps')}>📍 {t.lcPosGps}{pos?.acc ? ` ±${Math.round(pos.acc)} m` : ''}</button>
      <button type="button" className={`chip seg ${src === 'cross' ? 'on' : ''}`} data-testid={`${pre}-src-cross`} onClick={() => setSrc('cross')}>✚ {t.lcPosCross}</button>
    </div>
  );
}

export const pickAt = (src, pos, mapRef) => {
  if (src === 'gps' && pos) return { lat: pos.lat, lon: pos.lon };
  const c = mapRef.current.getCenter();
  return { lat: c.lat, lon: c.lng ?? c.lon };
};

const gpsOnce = () => new Promise((res) => {
  if (!navigator.geolocation) return res(null);
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lon: p.coords.longitude }), () => res(null), { enableHighAccuracy: true, timeout: 6000, maximumAge: 60000 });
});

// deployment round: sort open plan entries from current position, open Google Maps with all stops
export async function startRound(plan, setPlan, keep) {
  const open = plan.filter((p) => !p.doneAt);
  if (!open.length) return [];
  const w = window.open('', '_blank');
  const here = await gpsOnce();
  const ord = keep ? open : orderStops(here || open[0], open).map(({ dist: _d, ...p }) => p);
  if (!keep) setPlan([...plan.filter((p) => p.doneAt), ...ord]);
  const legs = routeLegs(here, ord);
  if (w) w.location.href = legs[0].url; else window.open(legs[0].url, '_blank', 'noopener');
  return legs;
}
export const openPlanTab = (tab) => window.dispatchEvent(new CustomEvent('giss-lgplan-open', { detail: { tab } }));
